function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#20205E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M78.3978 59.5042L66.4417 71.405L58.0723 63.0744L61.6592 59.5042L66.4417 64.2645L74.811 55.9339L78.3978 59.5042ZM53.2899 61.8843H29.3775V38.0827L48.5074 49.9835L67.6373 38.0827V49.9835H72.4198V33.3223C72.4198 30.7042 70.2676 28.562 67.6373 28.562H29.3775C26.7472 28.562 24.595 30.7042 24.595 33.3223V61.8843C24.595 64.5025 26.7472 66.6447 29.3775 66.6447H53.2899V61.8843ZM67.6373 33.3223L48.5074 45.2232L29.3775 33.3223H67.6373Z",
  fill: "white"
});

var SvgEmailSignup = function SvgEmailSignup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailSignup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-signup.0ce5b19c.svg";
export { ForwardRef as ReactComponent };